<template>
  <div class="register">
    <div class="register__container">
      <div class="register__brand">
        <img class="tingg-brand-logo" src="https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png" alt="Tingg"/>
      </div>

      <div class="register__card row no-gutters">
        <div class="col-md-6">
          <ul class="wizard-vertical">
            <li class="wizard-vertical__step active">
              <span class="wizard-vertical__step__count">1</span> Profile Information
            </li>
            <li class="wizard-vertical__divider"></li>
            <li class="wizard-vertical__step">
              <span class="wizard-vertical__step__count">2</span> Business Information
            </li>
            <li class="wizard-vertical__divider"></li>
            <li class="wizard-vertical__step">
              <span class="wizard-vertical__step__count">3</span> Complete
            </li>
          </ul>
        </div>

        <div class="col-md-6 register__form-section">
          <form @submit.prevent="submit">
            <div :class="{'form-group': true, 'has-error': errors.has('full_name') }">
              <label class="mula-form-group__label control-label" for="full_name">Full name</label>
              <span class="help muted subtle-text mt-0 mb-2">Please provide your full name separated by spaces</span>
              <input v-validate="'required|min:5'"
                     class="mula-form-group__input form-control"
                     id="full_name"
                     name="full_name"
                     type="text"
                     autocomplete="full_name"
                     v-model="full_name"
              >
              <span v-show="errors.has('full_name')" class="help is-danger">
                {{ errors.first('full_name') }}
              </span>
            </div>

            <div :class="{'form-group': true, 'has-error': errors.has('work_email') }">
              <label class="mula-form-group__label control-label" for="work_email">Work Email</label>
              <input v-validate="'required|email'"
                     class="mula-form-group__input form-control"
                     id="work_email"
                     name="work_email"
                     type="email"
                     autocomplete="work_email"
                     v-model="email"
              >
              <span v-show="errors.has('work_email')" class="help is-danger">
                {{ errors.first('work_email') }}
              </span>
            </div>

            <div :class="{'form-group': true, 'has-error': errors.has('password') }">
              <label class="mula-form-group__label control-label" for="password">Password</label>
              <input v-validate="'required|min:5'"
                     class="mula-form-group__input form-control"
                     id="password"
                     name="password"
                     type="password"
                     autocomplete="new_password"
                     v-model="password"
              >
              <span v-show="errors.has('password')" class="help is-danger">
                {{ errors.first('password') }}
              </span>
            </div>

            <div class="register__navigation">
              <vue-recaptcha ref="recaptcha"
                             @verify="verifyCaptcha"
                             @expired="captchaExpired"
                             size="invisible"
                             sitekey="6Lc23akUAAAAANu7aDnhQLXp48SvyZE_y4qJl9cA">
                <button class="ml-btn ml-btn--md tingg-primary-button" type="submit">
                  <span>Next</span>
                  <i class="fas fa-chevron-right"></i>
                </button>
              </vue-recaptcha>
            </div>
          </form>
          <div class="register__secondary-cta">
            <span>Already have an account?</span>
            <a class="tingg-anchors" href="#" @click.prevent="goTo('/login')">Login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import { mapActions, mapGetters } from 'vuex'

  const logInfo = process.env.NODE_ENV

  export default {
    components: {VueRecaptcha},

    computed: {
      ...mapGetters('registration', ['userInformation'])
    },

    data () {
      return {
        email: '',
        full_name: '',
        password: '',
        recaptcha_token: '',
        rcapt_id: 0
      }
    },

    methods: {
      ...mapActions('registration', ['persist']),

      captchaExpired () {
        logInfo && console.log('The captcha just expired')
        this.$refs.recaptcha.reset()
      },

      verifyCaptcha (token) {
        logInfo && console.log('The user is no bot')
        logInfo && console.log('Token received is: ', token)
        this.$btn.disable('button[type="submit"]')
        this.$validator.validateAll()
          .then(result => {
            logInfo && console.log('Did the user information pass validation?', result)
            if (result) {
              this.persist({emailAddress: this.email, fullName: this.full_name, password: this.password})
              this.$router.push('/register/business')
            } else {
              this.$btn.enable('button[type="submit"]')
              this.$refs.recaptcha.reset()
            }
          })
          .catch(reason => {
            logInfo && console.log('Failed to validate the user information during registration', reason)
            this.$btn.enable('button[type="submit"]')
            this.$refs.recaptcha.reset()
          })
      },

      submit () {
        this.$btn.disable('button[type="submit"]')
        this.$refs.recaptcha.execute()
      }
    },
    mounted () {
      let userInfo = this.userInformation

      logInfo && console.log('Saved user information: ', userInfo)

      // Populate the data fields
      if (userInfo != null) {
        this.email = userInfo.emailAddress
        this.full_name = userInfo.fullName
        this.password = ''
      }
    },
    name: 'RegisterUser'
  }
</script>

<style lang="scss">
  @import "../styles/theme";

  .tingg-anchors {
    color: $tingg-purple !important;
  }

  .register {
    width: 100%;
    min-height: 100vh;
    border-radius: 2px;

    display: flex;
    align-items: start;
    justify-content: center;
    background-image: linear-gradient(to bottom right, $tingg-primary-red, $tingg-purple);
  }

  .register__container {
    @include make-col-ready();

    @include media-breakpoint-down(xl) {
      @include make-col(8);
    }

    @include media-breakpoint-down(md) {
      @include make-col(10);
    }

    @include media-breakpoint-down(sm) {
      @include make-col(10);
    }

    @include media-breakpoint-down(xs) {
      @include make-col(12);
    }

    height: 75%;

    margin-top: 2.5rem;
  }

  .register__card {
    width: 100%;
    min-height: 100%;
    border-radius: 2px;
    padding: 1.5rem 3rem;
    background-color: $background-white;
  }

  .register__card-title {
    width: 100%;

    text-align: center;

    margin-bottom: 1.5rem;
  }

  .register__brand {
    width: 100%;

    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 2.5rem;
  }

  .iamnorobot__container {
    margin: 2rem 0 0;
  }

  .register__navigation {
    margin: 2rem 0;

    align-items: center;
    display: flex;
    flex-flow: row-reverse;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/views/RegisterUser.vue